import styled from 'styled-components';
import { opoButtonStyles, opoFormStyles, opoSegmentedStyles } from '../opo-styles';

export const SettingsPageWrapper = styled.div`
    max-width: 760px;

    ${opoFormStyles}

    .settings-card {
        margin-bottom: 20px;
        background: #FFFFFF;
        border: 1px solid #E3E8EF;
        border-radius: 12px;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
        overflow: hidden;
    }

    .settings-card-header {
        padding: 14px 20px;
        border-bottom: 1px solid #EEF1F5;
    }

    .settings-card-header h4 {
        margin: 0;
        font-size: 15px;
        font-weight: 600;
        color: #1F2A37;
    }

    .settings-card-body {
        padding: 16px 20px;
    }

    .settings-card-footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 12px 20px;
        border-top: 1px solid #EEF1F5;

        ${opoButtonStyles}
    }

    .settings-subsection {
        margin: 6px 0 12px;
        padding-top: 14px;
        border-top: 1px solid #EEF1F5;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #6B7A8F;
    }

    .settings-row {
        display: grid;
        grid-template-columns: 220px minmax(0, 420px);
        align-items: start;
        column-gap: 16px;
        margin-bottom: 12px;
    }

    .settings-row > .control-label {
        margin: 0;
        padding-top: 7px;
        font-size: 13px;
    }

    .settings-row > .control-label.wrap {
        white-space: normal;
    }

    .form-control[readonly],
    .form-control:disabled {
        background: #F3F5F8;
        color: #3A4756;
        cursor: default;
    }

    .file-input-group {
        display: flex;
        width: 100%;
    }

    .file-input-group > .btn {
        flex-shrink: 0;
        height: 32px;
        margin-left: -1px;
        padding: 0 12px;
        border-radius: 0;
        border: 1px solid #D5DBE3;
        background: #F3F5F8;
        color: #3A4756;
        font-size: 13px;
        font-weight: 500;
        white-space: nowrap;
        box-shadow: none;
    }

    .file-input-group > .btn:hover {
        background: #E8ECF1;
        color: #16365A;
    }

    .file-input-group > .btn:last-child {
        border-radius: 0 8px 8px 0;
    }

    .file-input-group > .form-control {
        flex: 1 1 auto;
        min-width: 0;
        border-radius: 8px 0 0 8px;
        background: #FFFFFF;
        color: #6B7A8F;
        text-overflow: ellipsis;
    }

    .file-input-group > .form-control:last-child {
        border-radius: 8px;
    }

    .settings-notice {
        margin-bottom: 16px;
        padding: 10px 14px;
        border: 1px solid #B9D3EE;
        border-left: 4px solid #337AB7;
        border-radius: 8px;
        background: #E8F1FB;
        font-size: 13px;
        font-weight: 500;
        color: #16365A;
    }

    .settings-hint {
        margin-top: 4px;
        font-size: 12px;
        color: #6B7A8F;
    }

    .has-error .form-control,
    .has-error .form-control:focus {
        border-color: #A3201A;
    }

    .help-block {
        margin: 4px 0 0;
        font-size: 12px;
        color: #A3201A;
    }

    ${opoSegmentedStyles}
`;
